
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("l0e0U", function(module, exports) {
const $f4a477e6c987efbb$var$scrollUpElement = document.getElementById("c-scroll-up");
if ($f4a477e6c987efbb$var$scrollUpElement !== null) {
    const offsetFromTop = Number($f4a477e6c987efbb$var$scrollUpElement.getAttribute("data-offset-from-top")) || 100; // if not set default is 100px
    const isInLimit = ()=>document.body.scrollTop > offsetFromTop || document.documentElement.scrollTop > offsetFromTop;
    const scrollHandle = ()=>{
        $f4a477e6c987efbb$var$scrollUpElement.classList.toggle("--active", isInLimit());
    };
    const scrollTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    window.onscroll = scrollHandle;
    $f4a477e6c987efbb$var$scrollUpElement.addEventListener("click", scrollTop);
}

});


//# sourceMappingURL=scroll-up.d746684f.js.map
